import { useNavigate } from "react-router-dom";
import { Box, SimpleGrid } from "@chakra-ui/react";
import { FACILITIES, HERO_IMAGES } from "./facilityData";

export default function GroundBookingListing() {
  const navigate = useNavigate();

  return (
    <div>
      {/* Hero */}
      <Box
        position="relative"
        overflow="hidden"
        display="grid"
        gridTemplateColumns="1fr 1fr 1fr"
        h={{ base: "150px", md: "220px" }}
      >
        {HERO_IMAGES.map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(0.45)" }}
          />
        ))}
        <Box position="absolute" inset={0} display="flex" alignItems="center" justifyContent="center">
          <h1 style={{ color: "#fff", fontSize: "clamp(1.3rem, 4vw, 2.8rem)", fontWeight: 700, textShadow: "0 2px 10px rgba(0,0,0,0.7)", textAlign: "center", margin: 0 }}>
            खेल मैदान बुक करें
          </h1>
        </Box>
      </Box>
      <div style={{ height: 3, background: "linear-gradient(to right, #0047ab, #1a7ff4)" }} />

      {/* Category grid */}
      <Box maxW="1100px" mx="auto" px={{ base: 4, md: 5 }} py={{ base: 8, md: 10 }}>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 8, md: 10 }}>
          {FACILITIES.map((facility) => (
            <Box
              key={facility.id}
              cursor="pointer"
              onClick={() => navigate(`/ground-booking/${facility.id}`)}
            >
              <h2 style={{ color: "#0047ab", fontSize: "1.15rem", fontWeight: 700, marginBottom: 10, borderBottom: "2px solid #0047ab", paddingBottom: 6, display: "inline-block" }}>
                {facility.nameHi}
              </h2>
              <Box borderRadius={10} overflow="hidden" boxShadow="0 2px 12px rgba(0,0,0,0.10)">
                <img
                  src={facility.listingImage}
                  alt={facility.nameHi}
                  style={{ width: "100%", height: 260, objectFit: "cover", display: "block", transition: "transform 0.25s" }}
                  onMouseEnter={e => (e.currentTarget.style.transform = "scale(1.03)")}
                  onMouseLeave={e => (e.currentTarget.style.transform = "scale(1)")}
                />
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </div>
  );
}
